
function currencyFormatted (value) {
  // console.log('value', value, typeof value);

  if (typeof value === 'string') {
    value = value.replace(/[$,]/g, '');
  }

  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 2,
  }).format(value);

}

// Compare two account/parent names A–Z (case-insensitive), with names that
// start with a letter ordered before those starting with a number or symbol.
// Shared by the account picker and the statement summary/detail grouping so
// the picker order and rendered/downloaded output always agree.
function compareAccountNames (a, b) {
  const nameA = (a || '').trim();
  const nameB = (b || '').trim();
  const aLetter = /^[a-z]/i.test(nameA);
  const bLetter = /^[a-z]/i.test(nameB);
  if (aLetter !== bLetter) return aLetter ? -1 : 1;
  return nameA.localeCompare(nameB, undefined, { sensitivity: 'base' });
}

module.exports = {
  currencyFormatted,
  compareAccountNames
};